export enum ExportStatus {
    WaitingUserAction = "waiting-user-action",
    GeneratingFile = "generating-file",
    GotAnError = "got-an-error",
    Done = "done",
}

export enum DisplayState {
    show = 'show',
    hidden = 'hidden',
    remove = 'remove',
}

export enum Permission {
    read = 'read',
    write = 'write',
}


export enum EstimateLineNoticeType {
    error = 'error',
    warning = 'warning',
    notice = 'info',
}
